import { render } from "./UserManualDetail.vue?vue&type=template&id=256e78b4"
import script from "./UserManualDetail.vue?vue&type=script&lang=js"
export * from "./UserManualDetail.vue?vue&type=script&lang=js"

import "./UserManualDetail.vue?vue&type=style&index=0&id=256e78b4&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__